import { Marker } from 'leaflet';
import { MapMarkerController } from 'src/controllers';
import { TBarPosition } from 'src/types/mixed.type';
import { MapUnit, UnitType } from 'src/types/unit.type';

export interface OverlappedUnitsPropTypes {
  mapMarkerController: MapMarkerController | undefined;
}

export type OverlappedMarker = {
  id: number;
  unit: MapUnit;
  marker: Marker;
  icon: L.DivIcon;
  unitType: UnitType;
};

export type OverlappedUnitsPopupArgs = {
  markers: OverlappedMarker[];
  mouseEvent: L.LeafletMouseEvent;
};

export type OverlappedUnitsPopupContent = OverlappedUnitsPopupArgs & {
  position: TBarPosition | undefined;
};

const calculateOverlappedUnitsPopup = (x: number, y: number, markersLength: number) => {
  const sidebarWidth = document.getElementsByClassName('map-sidebar-container')[0]?.getBoundingClientRect().width;
  let posX: number = x;
  let posY: number = y;

  if (sidebarWidth) {
    if (x < 100) {
      posX = x - sidebarWidth;
    } else if (sidebarWidth < 300) {
      posX = x - 380;
    } else {
      posX = x - 640;
    }
  }

  if (y > 450) {
    if (markersLength < 18) {
      const multiplier = markersLength / 3;
      posY = y - 70 * multiplier;
    } else {
      posY = y - 400;
    }
  } else {
    posY = y - 40;
  }

  return {
    x: posX,
    y: posY,
  };
};

// Render overlapped units popup as antd message
export const overlappedUnitsPopup = ({
  markers,
  mouseEvent,
}: OverlappedUnitsPopupArgs): OverlappedUnitsPopupContent | undefined => {
  const rect = document
    .getElementsByClassName(`unit-icon-${markers[0].marker.options.unitId}`)[0]
    ?.getBoundingClientRect();

  if (!rect) return undefined;

  return {
    markers,
    mouseEvent,
    position: calculateOverlappedUnitsPopup(rect.x, rect.y, markers.length),
  };
};
